export enum ACTIONS {
  EXIT_FORM = 'EXIT_FORM',
  FINISH_FORM = 'FINISH_FORM',
  NEXT = 'NEXT',
  PREVIOUS = 'PREVIOUS',
  AUTH_CHANGED = 'AUTH_CHANGED',
}
